import { IJwtTokenResponse } from 'multirpc-sdk';

import { JWT } from '../types';
import { decodeJWT } from './decodeJWT';
import { isPrimaryJWTIndex } from './isPrimaryJWTIndex';

export interface IDecodeJWTsProps {
  hasGroupSelected: boolean;
  jwts: IJwtTokenResponse[];
  primaryUserEndpointToken?: string;
}

export const decodeJWTs = async ({
  hasGroupSelected,
  jwts,
  primaryUserEndpointToken,
}: IDecodeJWTsProps) => {
  const promises = jwts.map<Promise<JWT>>(
    async ({
      description,
      index,
      is_encrypted: isEncrypted,
      jwt_data: token,
      name,
    }) => {
      if (!hasGroupSelected && isPrimaryJWTIndex(index)) {
        return {
          description,
          index,
          name,
          userEndpointToken: primaryUserEndpointToken ?? '',
        };
      }

      const decodedJWT = await decodeJWT({ isEncrypted, token });

      return {
        description,
        index,
        name,
        userEndpointToken: decodedJWT.workerTokenData?.userEndpointToken ?? '',
        partnerChains: decodedJWT.workerTokenData?.partnerChains ?? undefined,
      };
    },
  );

  const decodedJwts = await Promise.all(promises);

  return decodedJwts;
};
